import { render } from "./PartOrderDetail.vue?vue&type=template&id=a1a31f9a&scoped=true&bindings={}"
import script from "./PartOrderDetail.vue?vue&type=script&lang=ts"
export * from "./PartOrderDetail.vue?vue&type=script&lang=ts"

import "./PartOrderDetail.vue?vue&type=style&index=0&id=a1a31f9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a1a31f9a"

export default script